import React, { useState, useEffect } from "react";
import axios from "axios";
import { useToast } from "./otherHooks/useToast";

const CartContext = React.createContext<any>({} as any);

export const CartProvider = ({ children }: any) => {
  const { addToast } = useToast();

  const [cart, setCart] = useState([]);
  const [loadingRemoveCart, setLoadingRemoveCart] = useState(null);
  const [loadingAddCart, setLoadingAddCart] = useState(null);
  const [totalCost, setTotalCost] = useState(0);

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    if (localStorage.getItem("access")) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.getItem("access")}`,
          Accept: "application/json",
        },
      };

      // setLoading(itemId);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/course/bk-manage-cart`,
          config
        );
        setCart(response.data.cart_items);
        setTotalCost(response.data.total_cost);
      } catch (error) {
        console.error("Failed to fetch cart:", error);
      } finally {
        // setLoading(null);
      }
    } else {
      console.error("User not authenticated");
      return [];
    }
  };

  const addToCart = async (itemId, itemType, presence, title) => {
    if (localStorage.getItem("access")) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.getItem("access")}`,
          Accept: "application/json",
        },
      };

      setLoadingAddCart(title);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/course/bk-manage-cart`,
          {
            action: "add",
            id: itemId,
            type: itemType,
            presence: presence,
          },
          config
        );

        addToast({
          message: `${title} added to cart`,
          bg: "success",
        });
        setCart(response.data.cart_items);
        setTotalCost(response.data.total_cost);
      } catch (error) {
        console.error("Failed to add item to cart:", error);
        addToast({
          message: error.response?.data?.error || "Failed to add item to cart",
          bg: "danger",
        });
      } finally {
        setLoadingAddCart(null);
      }
    } else {
      addToast({
        message: "Login to add item to cart",
        bg: "danger",
      });
      console.error("User not authenticated");
      return [];
    }
  };

  const removeFromCart = async (itemId, itemType, presence, title) => {
    if (localStorage.getItem("access")) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.getItem("access")}`,
          Accept: "application/json",
        },
      };
      setLoadingRemoveCart(title);
      alert(`${title} would be remove from cart`);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/course/bk-manage-cart`,
          {
            action: "remove",
            id: itemId,
            type: itemType,
            presence: presence,
          },
          config
        );
        setCart(response.data.cart_items);
        setTotalCost(response.data.total_cost);

        addToast({
          message: `${title} removed from cart`,
          bg: "success",
        });
      } catch (error) {
        console.error("Failed to remove item from cart:", error);
      } finally {
        setLoadingRemoveCart(null);
      }
    } else {
      addToast({
        message: "Login to remove item from cart",
        bg: "danger",
      });
      console.error("User not authenticated");
      return [];
    }
  };

  const checkInCart = (itemId, itemType, presence) => {
    return cart.some((cartItem) => {
      return (
        cartItem.type === itemType &&
        cartItem.item?.id === itemId &&
        cartItem.presence === presence
      );
    });
  };
  return (
    <CartContext.Provider
      value={{
        cart,
        loadingAddCart,
        loadingRemoveCart,
        addToCart,
        removeFromCart,
        totalCost,
        checkInCart,
        fetchCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

// Custom hook to use Cart context
export const useCart = (): any => React.useContext(CartContext);
